module.exports = __webpack_public_path__ + "img/rasterized-gradient-blue-400.e7ed27c.png";